import React, { Component } from 'react'
import { SearchOptions } from '../../../components/TableHelper'
import { MappingCharacteristicConsumer } from '../../../context/MappingCharacteristicContext'
import MappingCharacteristicList from 'components/MappingCharacteristicList'

type MappingCharacteristicProps = {
  filters: any | null,
  history: any,
  permissions: any,

  onLoad?: (searchOptions: SearchOptions) => void
}

export default class MappingCharacteristic extends Component<MappingCharacteristicProps> {

  handleOnLoad = (searchOptions: SearchOptions) => {
    if (this.props.onLoad) {
      this.props.onLoad(searchOptions)
    }
  }

  render() {
    const { permissions, filters, history } = this.props

    return (
      <MappingCharacteristicConsumer>
        {({ fetching, mappingCharacteristics, pagination, requestMappingCharacteristicList }) => {

          return <MappingCharacteristicList permissions={permissions} loading={fetching} mappingCharacteristics={mappingCharacteristics} pagination={pagination} filters={filters} history={history} onLoad={this.handleOnLoad} loadMappingCharacteristics={requestMappingCharacteristicList} />
        }}
      </MappingCharacteristicConsumer>
    )
  }
}
